import { FileTranscriptStatus } from '@/enums';
import type { WorkspaceFileTranscript } from '@/types/workspace';

export function assertCanTranscribeFile(transcript: WorkspaceFileTranscript) {
  return transcript != null && !transcript.id &&
    transcript.meta.canTranscribe &&
    ![FileTranscriptStatus.Complete, FileTranscriptStatus.InProgress].includes(transcript?.status);
}